/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { ActionsObservable, StateObservable } from 'redux-observable';
import { isOfType } from 'typesafe-actions';
import { filter, map, mergeMap } from 'rxjs/operators';
import { catchError } from 'rxjs/internal/operators/catchError';
import { from, of } from 'rxjs';

import {
  getCartSummarySuccess,
  getCartSummaryFailed,
  GetCartSummaryAction,
  GetCartSummaryActionTypes,
} from '../actions/GetCartSummary';
import getCartSummaryService from '../services/GetCartSummary';
import RootState from '../../../config/store/RootState';
import RootAction from '../../../config/store/RootAction';

const GetCartSummaryEpic = (action$: ActionsObservable<RootAction>, state$: StateObservable<RootState>) => action$.pipe(
  filter(isOfType(GetCartSummaryActionTypes.GET_CART_SUMMARY)),
  mergeMap((action: GetCartSummaryAction) => from(
    getCartSummaryService(action.payload.cartAliasId, action.payload.filter),
  ).pipe(
    map((response: any) => getCartSummarySuccess({ cartSummary: response.data.getCartSummary.data })),
    catchError((error: any) => of(
      getCartSummaryFailed({
        errorCode: error.errorCode || error.networkError?.statusCode || 500,
        errorMessage: error.errorMessage || error?.networkError?.result?.error_message as string,
        callBack: error.callBack,
      }),
    )),
  )),
);

export default GetCartSummaryEpic;
